interface ContentfulHeaderRibbon {
  ribbonLink?: string;
  // Add other optional fields if needed
}

interface GetDerivedHeaderFlagsParams {
  pathname?: string;
  initialPromoVariant?: string;
  contentfulHeaderRibbon?: ContentfulHeaderRibbon;
}

interface DerivedHeaderFlags {
  promoVariant?: string;
  isAccountPage: boolean;
  isQuizLp: boolean;
  showCart: boolean;
  isTarget: boolean;
  showSiteSwitch: boolean;
}

export const getDerivedHeaderFlags = ({
  pathname,
  initialPromoVariant,
  contentfulHeaderRibbon,
}: GetDerivedHeaderFlagsParams): DerivedHeaderFlags => {
  let promoVariant = initialPromoVariant;
  let isAccountPage = false;
  let isQuizLp = false;
  let showCart = true;
  let isTarget = false;
  let showSiteSwitch = true;

  if (pathname) {
    showCart = !pathname.includes("/checkout");
    isAccountPage = pathname.includes("account/");
    isQuizLp = pathname.includes("hair-wellness-quiz-intro");
    showSiteSwitch = !pathname.includes("travel-kit-offer");

    isTarget =
      pathname === contentfulHeaderRibbon?.ribbonLink &&
      pathname !== "/hair/brand/product/category/";
  }

  if (isTarget) {
    promoVariant = "ribbon_products";
  }

  return {
    promoVariant,
    isAccountPage,
    isQuizLp,
    showCart,
    isTarget,
    showSiteSwitch,
  };
};
